import { MutableRefObject, useRef, useState, useCallback, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import NextImage from '@/components/NextImage';
import { getTeaserYoutubeMap } from '@/constants/delta2max';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { VideoBtnSvg } from '@/components/UI/svg/delta2max';

const YouTubeName: any = {
    1: 'DELTA 2 Max-No Fume',
    2: 'DELTA 2 Max-No Noise',
    3: 'DELTA 2 Max-Maintenance-Free',
    4: 'DELTA 2 Max-Home Backup',
};

export default function C() {
    const { useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('delta2max.detail');
    const { locale } = useRouter();

    const videoRef1 = useRef<MutableRefObject<any>>(null);
    const videoRef2 = useRef<MutableRefObject<any>>(null);
    const videoRef3 = useRef<MutableRefObject<any>>(null);
    const videoRef4 = useRef<MutableRefObject<any>>(null);
    const [tabActive, setTabActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const domRef = useRef<HTMLDivElement>(null);
    const domChildRef = useRef<HTMLDivElement>(null);
    const arrLeftRef = useRef<Array<number>>([0]);
    const arrWidthRef = useRef<Array<number>>([]);
    const zoomRef = useRef<HTMLDivElement>(null);
    // 视频异步加载延迟资源
    const [sources1, setSources1] = useState<string[] | null>(null);
    const [sources2, setSources2] = useState<string[] | null>(null);
    const [sources3, setSources3] = useState<string[] | null>(null);
    const [sources4, setSources4] = useState<string[] | null>(null);
    const youtubeMap = getTeaserYoutubeMap(locale);
    const [curYoutube, setCurYoutube] = useState('');

    const initMove = useCallback((dom: any, arrHRef: number[], arrTRef: number[]) => {
        const child = dom.children;
        const len = child?.length || 0;
        for (let i = 0; i < len - 1; i++) {
            const item = child[i];
            arrHRef.push(item.clientWidth);

            if (i === len - 2) {
                break;
            }
            if (i !== 0) {
                arrTRef.push(arrTRef[i] + item.clientWidth + 40);
            } else {
                arrTRef.push(item.clientWidth + 40);
            }
        }
    }, []);

    const changeTab = useCallback((index: number) => {
        setTabActive(index);
        const ind = Number(index);
        (domChildRef.current as HTMLDivElement).style.cssText = `width: ${arrWidthRef.current[ind]}px; left: ${arrLeftRef.current[ind]}px`;
    }, []);

    const swiperChange = (e: any) => {
        onSwiperSlideTo(e.activeIndex);
    };

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== tabActive) {
            swiper?.slideTo(index);
        }
        changeTab(index);
    };

    useEffect(() => {
        // PC 适配小屏幕尺寸 小于840尺寸的
        // const pageHeight = document.documentElement.clientHeight;
        // if (pageHeight < 840) {
        //     const sclae = document.documentElement.clientHeight / zoomBoundHeight;
        //     (zoomRef.current as HTMLDivElement).style.cssText = `transform:scale(${sclae})`;
        // }

        // 初始化tab1切换数据
        initMove(domRef.current, arrWidthRef.current, arrLeftRef.current);
        changeTab(0);
        setSources1(['/video/delta2max/detail/pc/3-1_pc.webm', '/video/delta2max/detail/pc/3-1_pc.mp4']);
        setSources2(['/video/delta2max/detail/pc/3-2_pc.webm', '/video/delta2max/detail/pc/3-2_pc.mp4']);
        setSources3(['/video/delta2max/detail/pc/3-3_pc.webm', '/video/delta2max/detail/pc/3-3_pc.mp4']);
        setSources4(['/video/delta2max/detail/pc/3-4_pc.webm', '/video/delta2max/detail/pc/3-4_pc.mp4']);
    }, []);

    const onChangeYtb = (index: number) => {
        setCurYoutube(youtubeMap[index]);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: YouTubeName[index],
            position: 'Product Detail_1',
        });
    };

    return (
        <div ref={zoomRef} className={`d2x-detail-C ${css.d2xDetailC}`}>
            <p className="title">{t('sec3_1_title')}</p>
            <div className="video-content">
                <Swiper
                    pagination={false}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    effect="fade"
                    spaceBetween={0}
                    onSlideChange={swiperChange}
                    onSwiper={(swiper: any) => setSwiper(swiper)}
                >
                    <SwiperSlide className="video-box" onClick={() => onChangeYtb(1)}>
                        <EFVideo ref={videoRef1} autoPlay={true} className="video" sources={sources1} />
                    </SwiperSlide>
                    <SwiperSlide className="video-box" onClick={() => onChangeYtb(2)}>
                        <EFVideo ref={videoRef2} autoPlay={true} className="video" sources={sources2} />
                    </SwiperSlide>
                    <SwiperSlide className="video-box" onClick={() => onChangeYtb(3)}>
                        <EFVideo ref={videoRef3} autoPlay={true} className="video" sources={sources3} />
                    </SwiperSlide>
                    <SwiperSlide className="video-box" onClick={() => onChangeYtb(4)}>
                        <EFVideo ref={videoRef4} autoPlay={true} className="video" sources={sources4} />
                    </SwiperSlide>
                </Swiper>
                <div className="pagination">
                    {[0, 1, 2, 3].map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`img-box ${index == tabActive ? 'active' : ''}`}
                                onClick={() => {
                                    onSwiperSlideTo(index);
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'video',
                                        title_name: YouTubeName[index + 1],
                                        position: 'Product Detail_1',
                                    });
                                }}
                            >
                                <NextImage
                                    webpSrc={require(`@publicLocal/delta2max/detail/pc/sec3_${index + 1}.webp`)}
                                    src={require(`@publicLocal/delta2max/detail/pc/sec3_${index + 1}.png`)}
                                />
                                <div className="video-btn">
                                    <VideoBtnSvg />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div ref={domRef} className={`tab active-0${tabActive}`}>
                <button
                    onClick={() => {
                        onSwiperSlideTo(0);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec3_tab1'),
                            list_name: t('sec3_title'),
                        });
                    }}
                >
                    {t('sec3_tab1')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(1);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec3_tab2'),
                            list_name: t('sec3_title'),
                        });
                    }}
                >
                    {t('sec3_tab2')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(2);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec3_tab3'),
                            list_name: t('sec3_title'),
                        });
                    }}
                >
                    {t('sec3_tab3')}
                </button>
                <button
                    onClick={() => {
                        onSwiperSlideTo(3);
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'tab_click',
                            button_name: t('sec3_tab4'),
                            list_name: t('sec3_title'),
                        });
                    }}
                >
                    {t('sec3_tab4')}
                </button>
                <span ref={domChildRef}></span>
            </div>
            <div className="desc">{t(`sec3_desc${tabActive}`)}</div>
            <EFVideoModal
                visible={Boolean(curYoutube)}
                source={curYoutube}
                onClose={() => setCurYoutube('')}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
